module.exports = __webpack_public_path__ + "img/nn.d3f12ad3.gif";